// extracted by mini-css-extract-plugin
export default {"info":"static-data_info__gmJLb","infoItem":"static-data_infoItem__hf-Vw","trackLink":"static-data_trackLink__gQqnf","comment":"static-data_comment__ZVZcu"};